/**
 * Route path constants used throughout the application
 */
export const ROUTE_PATHS = {
  lock: 'lock',
  lockPinCode: 'pin-code',
  lockNoInternet: 'no-internet',
  lockInitialConfiguration: 'initial-configuration',
  lockSomethingWrong: 'something-wrong',
  dashboard: 'dashboard',
  water: 'water',
  hvac: 'hvac',
  air: 'air',
  energy: 'energy',
  settings: 'settings',
  setPin: 'set-pin',
  resetPin: 'reset-pin',
  disablePin: 'disable-pin',
  weather: 'weather',
  wifi: 'wifi',
  connectWifi: 'connect-wifi',
  lockScreen: 'lock-screen',
  contact: 'contact',
  screenSaver: 'screensaver',
  backlight: 'backlight',
};

/**
 * Full pathnames constructed from route paths
 */
export const ROUTE_PATHNAMES = {
  lock: `/${ROUTE_PATHS.lock}`,
  lockPinCode: `/${ROUTE_PATHS.lock}/${ROUTE_PATHS.lockPinCode}`,
  lockNoInternet: `/${ROUTE_PATHS.lock}/${ROUTE_PATHS.lockNoInternet}`,
  lockInitialConfiguration: `/${ROUTE_PATHS.lock}/${ROUTE_PATHS.lockInitialConfiguration}`,
  lockSomethingWrong: `/${ROUTE_PATHS.lock}/${ROUTE_PATHS.lockSomethingWrong}`,
  dashboard: `/${ROUTE_PATHS.dashboard}`,
  water: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.water}`,
  hvac: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.hvac}`,
  air: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.air}`,
  energy: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.energy}`,
  settings: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}`,
  setPin: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.setPin}`,
  resetPin: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.resetPin}`,
  disablePin: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.disablePin}`,
  weather: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.weather}`,
  wifi: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.wifi}`,
  backlight: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.backlight}`,
  connectWifi: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.connectWifi}/:networkName`,
  lockScreen: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.lockScreen}`,
  contact: `/${ROUTE_PATHS.dashboard}/${ROUTE_PATHS.settings}/${ROUTE_PATHS.contact}`,
  screenSaver: `/${ROUTE_PATHS.lock}/${ROUTE_PATHS.screenSaver}`,
};
